import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, inject, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { User, UserService } from '../../services/user.service';
import { ToastService } from '../toast.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-ias-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './ias-header.component.html',
  styleUrl: './ias-header.component.scss'
})
export class IasHeaderComponent implements OnInit {
  auth = inject(AuthService);
  dropdownOpen = false;
  user: User | null = null;
  private isBrowser: boolean;
  isLoggedIn: boolean | null = null;  // null by default
  userRole: string | null = null;
  constructor(
    private router: Router,
    private userService: UserService,
    private toastService: ToastService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  logout(): void {
    if (this.isBrowser) {
      localStorage.clear();   // 🔥 removes everything
      this.auth.checkAuth();
      this.isLoggedIn = false;
    }
    this.router.navigate(['']);
  }

  ngOnInit(): void {
    if (this.isBrowser) {

      const token = localStorage.getItem('authToken');
      this.userRole = localStorage.getItem('userRole') ? atob(localStorage.getItem('userRole')!) : null;
      this.isLoggedIn = !!token;

      if (this.isLoggedIn) {
        this.userService.getUser().subscribe({
          next: (user) => this.user = user,
          error: () => this.user = null
        });
      }
    }
  }

  getUserInitials(): string {
    if (!this.user?.doptOfficer?.englishName) return 'NA';

    // Split name by spaces and filter out honorifics
    const honorifics = ['shri', 'mr', 'ms', 'mrs', 'dr', 'prof'];
    const names = this.user.doptOfficer.englishName
      .trim()
      .split(/\s+/)
      .filter((n: string) => !honorifics.includes(n.toLowerCase()));

    if (names.length === 0) return 'NA';

    // If only one name left, just take first two letters
    if (names.length === 1) {
      return names[0].substring(0, 2).toUpperCase();
    }

    // Otherwise take first and last names
    const first = names[0].charAt(0).toUpperCase();
    const last = names[names.length - 1].charAt(0).toUpperCase();

    return first + last;
  }

  goHome() {
    if (this.router.url === '/homepage') {
      this.toastService.showToast('You are already on Webpage', 'success');
    } else {
      this.router.navigateByUrl('/homepage');
    }
  }
}
